import type { TunaThunkDispatch } from '@tunasong/redux'
import { entitiesApi } from '@tunasong/redux'
import { prefetchRecentSplit, prefetchSearch } from '@tunasong/search'
import { sharedSpacesSearch } from './use-home-spaces.js'

/** Home's paths: `/app` and `/app/` */
export const isHomePath = (pathname: string) => pathname === '/app' || pathname === '/app/'

/**
 * Start Home's first-screen data as soon as the session is known (GH #2903), instead of when Home renders: that waits
 * for every plugin and Home's own chunk. Each request uses the args of the hook that reads it, so the hook picks up
 * the prefetch instead of starting its own:
 * - my root entities: `useHomeSpaces` (graph-lib `useEntities`);
 * - spaces shared with me: `useHomeSpaces`;
 * - the recent feed: `useContinueItems` and the collaborators aside (`useRecentSplit`);
 * - access requests waiting on me: `WaitingOnYouSection`.
 *
 * What depends on these (the entities and profiles they name) still loads when Home renders.
 */
export const prefetchHome = (dispatch: TunaThunkDispatch, userId: string) => {
  dispatch(entitiesApi.util.prefetch('loadAllEntities', {}, {}))
  prefetchSearch(dispatch, sharedSpacesSearch(userId))
  prefetchRecentSplit(dispatch)
  dispatch(entitiesApi.util.prefetch('ownerAccessRequests', undefined, {}))
}
